import { render, staticRenderFns } from "./HomepageView.vue?vue&type=template&id=3b1c9c1c&scoped=true&"
import script from "./HomepageView.vue?vue&type=script&lang=js&"
export * from "./HomepageView.vue?vue&type=script&lang=js&"
import style0 from "./HomepageView.vue?vue&type=style&index=0&id=3b1c9c1c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1c9c1c",
  null
  
)

export default component.exports